import { render, staticRenderFns } from "./ecom-task-generator.vue?vue&type=template&id=47a87e0c&"
import script from "./ecom-task-generator.vue?vue&type=script&lang=js&"
export * from "./ecom-task-generator.vue?vue&type=script&lang=js&"
import style0 from "./ecom-task-generator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports